module.exports = __webpack_public_path__ + "static/media/versatilLogo.540ae4c6.png";